export type BuyerIncentiveName =
    | 'authenticityGuarantee'
    | 'moneyBackGuarantee'
    | 'cancelationPolicy'
    | 'vettedSellers'
    | 'priceMatch'
    | 'globalDelivery'
    | 'returnPolicy';

export const useBuyerIncentivesList = ({
    useAll = false,
}: {
    useAll?: boolean;
} = {}): BuyerIncentiveName[] => {
    const coreIncentives: BuyerIncentiveName[] = [
        'authenticityGuarantee',
        'moneyBackGuarantee',
        'cancelationPolicy',
    ];

    if (!useAll) {
        return coreIncentives;
    }

    return [...coreIncentives, 'vettedSellers', 'priceMatch', 'globalDelivery'];
};

export const useBuyerIncentivesHomepageList = (isTrade: boolean): BuyerIncentiveName[] => {
    if (isTrade) {
        const tradeIncentives: BuyerIncentiveName[] = [
            'authenticityGuarantee',
            'moneyBackGuarantee',
            'priceMatch',
            'vettedSellers',
            'globalDelivery',
            'returnPolicy',
        ];

        return tradeIncentives;
    }

    const incentives: BuyerIncentiveName[] = [
        'authenticityGuarantee',
        'moneyBackGuarantee',
        'priceMatch',
        'vettedSellers',
        'cancelationPolicy',
        'globalDelivery',
    ];

    return incentives;
};
